import { PostSection } from "@/components/blog/PostSection";
import { PostHighlight } from "@/components/blog/PostHighlight";

export function AutoridadMarcaSection() {
  return (
    <PostSection id="autoridad-marca-eeat" title="Autoridad de marca, E-E-A-T y señales de confianza">
      <p>
        Mientras en el SEO clásico los backlinks eran la métrica clave, en la nueva era del SEO importan 
        más la <strong>autoridad de marca</strong>, la reputación, la calidad del contenido y la 
        experiencia demostrada.
      </p>

      <h3 id="eeat-real" className="text-xl font-bold text-white mt-8 mb-4">
        E-E-A-T real: experiencia demostrada
      </h3>
      <PostHighlight>
        E-E-A-T (Experiencia, Expertise, Autoridad, Confiabilidad) ya no es un concepto teórico: 
        es el criterio principal que usan los modelos de IA para decidir qué fuentes citar.
      </PostHighlight>
      <p className="mt-4">
        Cómo demostrar E-E-A-T en tu web:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-4">
        <li><strong>Autoría visible:</strong> firma los artículos con perfil profesional, foto y bio</li>
        <li><strong>Experiencia real:</strong> incluye casos de éxito, capturas, datos propios y testimonios</li>
        <li><strong>Credenciales:</strong> muestra certificaciones, premios y reconocimientos</li>
        <li><strong>Actualización:</strong> fechas visibles de publicación y última revisión</li>
        <li><strong>Fuentes:</strong> cita datos verificables y enlaza a fuentes de autoridad</li>
      </ul>

      <h3 id="reputacion-digital" className="text-xl font-bold text-white mt-8 mb-4">
        Reputación digital y branding
      </h3>
      <p>
        Un sitio con buen branding, reseñas positivas y contenido con valor real tiene ventaja 
        incluso frente a sitios con muchos enlaces pero poco valor. Esto es especialmente relevante 
        cuando los motores de IA deciden qué fuentes citar.
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-4">
        <li>Gestiona activamente tus reseñas en Google Business Profile</li>
        <li>Construye presencia de marca en redes y directorios de autoridad</li>
        <li>Genera menciones de marca (branded search) con PR digital</li>
        <li>Mantén coherencia de mensaje en todos los canales</li>
      </ul>
    </PostSection>
  );
}
